import React from "react";
import {
    Box, IconButton, Tooltip, Typography, Paper, Chip, Stack
} from "@mui/material";
import SyncIcon from '@mui/icons-material/Sync';
import { isStatusDesync, STATUS_MAPPING } from "./ProducerDashboardHelper";



type SyncStatusProps = {
    one_comm_status: string
    institution_status: string
    institution: string
    handleSyncStatus: () => void;
    isUpdating: boolean
}

export default function SyncStatus({ one_comm_status, institution_status, institution, handleSyncStatus, isUpdating }: SyncStatusProps) {

    const renderStatusChip = (status: string) => {
        const config = STATUS_MAPPING[status];
        return <Chip label={config.label} color={config.color} size="small" sx={{ fontWeight: 'bold' }} />;
    };

    return (
        <Paper variant="outlined" sx={{ flex: 1, p: 2, borderRadius: 3, bgcolor: '#fcfcfc', border: '1px solid #e0e0e0' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 800 }}>Sync Status</Typography>
                {institution_status &&
                    isStatusDesync(one_comm_status, institution_status) && (
                        <Tooltip title="Force Sync Status">
                            <IconButton size="small" onClick={handleSyncStatus} disabled={isUpdating} sx={{ bgcolor: 'error.main', color: 'white', '&:hover': { bgcolor: 'error.dark' } }}>
                                <SyncIcon fontSize="inherit" />
                            </IconButton>
                        </Tooltip>
                    )}
            </Box>
            <Stack direction="row" spacing={4} mt={1}>
                <Box><Typography variant="caption" sx={{ fontWeight: 700, display: 'block' }}>ONECOMM</Typography>{renderStatusChip(one_comm_status)}</Box>
                {institution_status &&
                    <Box>
                        <Typography variant="caption" sx={{ fontWeight: 700, display: 'block' }}>{institution}</Typography>
                        {renderStatusChip(institution_status)}
                    </Box>}
            </Stack>
        </Paper>
    );
}